var map = {
	"./form.js": "./src/router/modules/form.js",
	"./project.js": "./src/router/modules/project.js",
	"./root.js": "./src/router/modules/root.js",
	"./work-order.js": "./src/router/modules/work-order.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/router/modules sync .js$";